import type { SxProps, Theme } from '@mui/material/styles';

/** Оформление раздела «Сотрудники точки» - токены «Пользователей» админки */
export const STAFF_PRIMARY = '#1570ef';

export const toolbarSx: SxProps<Theme> = {
  p: 1.5,
  borderRadius: 3,
  border: '1px solid #e2e8f0',
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 1.5
};

export const searchInputSx: SxProps<Theme> = {
  borderRadius: '8px',
  bgcolor: '#f8fafc',
  fontSize: '0.875rem',
  '& fieldset': { borderColor: '#e2e8f0' },
  '&:hover fieldset': { borderColor: '#cbd5e1 !important' },
  '&.Mui-focused fieldset': { borderColor: '#2563eb !important' }
};

export const primaryButtonSx: SxProps<Theme> = {
  height: 40,
  px: 2,
  borderRadius: '8px',
  fontWeight: 600,
  fontSize: '0.82rem',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  bgcolor: STAFF_PRIMARY,
  boxShadow: '0 2px 8px rgba(21,112,239,0.25)',
  '&:hover': { bgcolor: '#105ec2' }
};

export const outlinedButtonSx: SxProps<Theme> = {
  borderRadius: '8px',
  borderColor: '#e2e8f0',
  color: '#1e293b',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f8fafc' }
};

export const tableContainerSx: SxProps<Theme> = {
  borderRadius: 3,
  border: '1px solid #e2e8f0',
  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)',
  overflowX: 'auto'
};

/** Шапка таблицы задаётся на TableHead: ячейкам остаётся только своя ширина и скрытие на телефоне */
export const tableHeadSx: SxProps<Theme> = {
  '& .MuiTableCell-head': {
    fontWeight: 700,
    color: '#64748b',
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    bgcolor: '#f8fafc',
    whiteSpace: 'nowrap',
    py: 1.5
  }
};

export const cardSx: SxProps<Theme> = {
  p: 2.5,
  borderRadius: '12px',
  bgcolor: '#ffffff',
  border: '1px solid #e2e8f0'
};

export const sectionTitleSx: SxProps<Theme> = {
  fontWeight: 700,
  color: '#0f172a',
  fontSize: '0.95rem'
};

export const dialogPaperSx: SxProps<Theme> = { borderRadius: { xs: 0, sm: '20px' } };

export const dialogTitleSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  borderBottom: '1px solid #e2e8f0',
  py: 2
};

export const dialogIconSx: SxProps<Theme> = {
  width: 38,
  height: 38,
  flexShrink: 0,
  borderRadius: '10px',
  bgcolor: '#eff6ff',
  color: STAFF_PRIMARY,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

/** Чип статуса: активен - зелёный, заблокирован - оранжевый, как кнопка статуса в карточке «Пользователей» */
export const statusChipSx = (active: boolean): SxProps<Theme> => ({
  height: 24,
  fontWeight: 600,
  fontSize: '0.74rem',
  borderRadius: '6px',
  border: '1px solid',
  borderColor: active ? '#a7f3d0' : '#fed7aa',
  bgcolor: active ? '#ecfdf5' : '#fff7ed',
  color: active ? '#059669' : '#c2410c'
});

export const kindToggleSx: SxProps<Theme> = {
  flex: 1,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.85rem',
  color: '#475569',
  borderColor: '#e2e8f0',
  '&.Mui-selected': { bgcolor: '#eff6ff', color: STAFF_PRIMARY, borderColor: '#bfdbfe' },
  '&.Mui-selected:hover': { bgcolor: '#dbeafe' }
};

export const kindChipSx: SxProps<Theme> = {
  height: 24,
  fontWeight: 600,
  fontSize: '0.74rem',
  borderRadius: '6px',
  bgcolor: '#f1f5f9',
  color: '#475569'
};

export const monoBoxSx: SxProps<Theme> = {
  px: 1.5,
  py: 1,
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
  bgcolor: '#f8fafc',
  fontFamily: 'Consolas, "Roboto Mono", monospace',
  fontSize: '0.95rem',
  color: '#0f172a',
  wordBreak: 'break-all'
};
